import React from 'react';
import moment from 'moment';
import { Table } from 'reactstrap';
import imgfLoading from '../../assets/img/preloader-black.gif';
import { usePartnerListContext } from './PartnerListContext';
import { can } from '../../utils/permissions';

const PartnerList = ({ onEdit, onDeactivate }) => {
  const { aPartners, bIsLoading } = usePartnerListContext();

  return (
    <Table hover responsive striped>
      <PartnerListHeader />
      <tbody>
        {aPartners.map((oPartner) => (
          <PartnerListItem
            key={oPartner.wlpn_nid}
            oPartner={oPartner}
            onEdit={() => onEdit(oPartner)}
            onDeactivate={() => onDeactivate(oPartner)}
          />
        ))}
        {bIsLoading && (
          <tr>
            <td colSpan="7" className="centered-text">
              <img alt='Carregando' src={imgfLoading} /> Carregando...
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

const PartnerListHeader = () => {
  return (
    <thead>
      <tr>
				<th>#</th>
				<th>Nome</th>
				<th>Ativo</th>
				<th>Data de criação</th>
				<th>Ação</th>
			</tr>
		</thead>
  );
};

const PartnerListItem = ({
  oPartner = {},
  onEdit = () => {},
  onDeactivate = () => {},
}) => {
  return (
    <tr>
      <td>{oPartner.wlpn_nid}</td>
      <td title={oPartner.wlpn_cname}>
        <span className="container-config abbreviate-text">{oPartner.wlpn_cname}</span>
      </td>
      <td>{oPartner.wlpn_bisactive ? 'Sim' : 'Não'}</td>
      <td>{oPartner.wlpn_dcreated ? moment.parseZone(oPartner.wlpn_dcreated).format('DD/MM/YYYY H:mm') : ''}</td>
      <td>
        {can('edit-wlpartner') && (
          <a className="rounded-btn edit pointer" title="Visualizar informações ou editar" onClick={onEdit}>
            <i className="icon-edit" />
          </a>
        )}
        {/* &nbsp;&nbsp;&nbsp;
        {!!oPartner.wlpn_bisactive && (
          <a className="rounded-btn edit pointer" title="Desativar" onClick={onDeactivate}>
            <i className="icon-close" />
          </a>
        )} */}
      </td>
    </tr>
  );
};

export default PartnerList;